import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useAsyncResource } from "use-async-resource";

export type Gatekeeper = {
  auth: boolean;
  assign: boolean;
  verify: boolean;
  signalr: boolean;
  covidPass: boolean;
  credentialQRCode: boolean;
  selfCheck: boolean;
  notifications: boolean;
  vcVerifier: boolean;
};

function isActive(flag: string) {
  return flag === "true";
}

async function fetchGatekeepers(): Promise<Gatekeeper> {
  return new Promise((resolve) => {
    resolve({
      auth: isActive(import.meta.env.REACT_APP_AUTH),
      assign: isActive(import.meta.env.REACT_APP_ASSIGN),
      verify: isActive(import.meta.env.REACT_APP_VERIFY),
      signalr: isActive(import.meta.env.REACT_APP_SIGNALR),
      covidPass: isActive(import.meta.env.REACT_APP_COVID_PASS),
      credentialQRCode: isActive(import.meta.env.REACT_APP_CREDENTIAL_QR_CODE),
      selfCheck: isActive(import.meta.env.REACT_APP_SELF_CHECK),
      notifications: isActive(import.meta.env.REACT_APP_NOTIFICATIONS),
      vcVerifier: isActive(import.meta.env.REACT_APP_VC_VERIFIER),
    });
  });
}

export default function useGatekeeper(): Gatekeeper {
  const [reader] = useAsyncResource(fetchGatekeepers, []);
  return reader();
}

export function useGatekeeperRedirect(keys: Array<keyof Gatekeeper>) {
  const gks = useGatekeeper();
  const navigate = useNavigate();
  useEffect(() => {
    if (!keys.every((key) => gks[key])) {
      navigate("/");
    }
  }, [navigate, gks, keys]);
}
